import {  useEffect, useState  } from "react"
import { useLocation  , useNavigate} from 'react-router-dom';
import {registerUser} from '../../api/index'
import { toast } from 'react-hot-toast';


const universityCourses = {
  DIET: ["B.Tech. Civil", "B.Tech. Computer", "B.Tech. Mechanical" , "M.Tech. Software" ,"M.Tech. Structural" ,"M.Tech. Transportation" ,"M.Tech. Thermal" ,"M.Tech. Construction Project Management","M.Tech. Advanced Design & Manufacturing" , "Ph.D. CSE" ,"Ph.D. Civil" ,"Ph.D. Mechanical" ],
  DIETDS: ["Computer", "Civil", "Electrical", "Mechanical"],
  DICA: ["BCA", "MCA", "B.Sc.(IT)", "B.Sc. Honors(CS)"],
  DIM: ["MBA", "BBA","BBA-DM", "B.Com","B.Com (Hons.)", "Ph.D."],
  DIS: ["B.Sc. (Microbiology)", "Ph.D. (Microbiology)"],
  DIH:["M.A. (Yoga)"]
}




export default function Register() {
  const [selectedUniversity, setSelectedUniversity] = useState("");
  const location = useLocation();
  
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectName, setSelectName] = useState("");
  const [selectedGame, setSelectedGame] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedNumber, setSelectedNumber] = useState("");
  const [selectSemeter, setSelectSemester] = useState("");
  const [selectEnrollment, setSelectEnrollment] = useState("");
  const [selectPassword , setSelectPassowrd]=useState("");
  const [isSentMail , setIsSentMail]=useState(false);
  const navigate = useNavigate(); 
  const [timer, setTimer] = useState(120); // 2 minutes in seconds
  const [canResend, setCanResend] = useState(false);

  useEffect(()=>{
    if(window.localStorage.getItem('authToken')){
      window.location.href = "/";
    }
  },[])


  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleResendEmail = () => {
    submitFun();
    // Here you would implement your email resending logic
    setTimer(120);
    setCanResend(false);
  };


  const getCourses = () => {
    return selectedUniversity ? universityCourses[selectedUniversity] || [] : [];
  };
  
  const submitFun=()=>{
    if(selectPassword.length<6){
      toast.error("Password should be atleast 6 characters long");
      return;
    }
    if(selectedNumber.length!==10){
      toast.error("Phone number should be of 10 digits");
      return;
    }
    const data ={email:selectEnrollment+"@darshan.ac.in",name:selectName , enrollmentNumber:selectEnrollment , phone:selectedNumber , university:selectedUniversity , course:selectedCourse , semester:selectSemeter , tShirtSize:selectedSize , gender:selectedGender , redirectUrl:`${window.location.origin}/redirectPage` , password:selectPassword};
    registerUser(data).then((res)=>{
      setIsSentMail(true);
    setCanResend(false);
      setTimer(120);
      toast.success("Please check your email for verification");
    }).catch((err)=>{
      toast.error(err.message);
    })
  }


  return (
    <div className="min-h-screen p-4 md:p-8">
    {!isSentMail ? <>
      <div className="mx-auto max-w-2xl overflow-hidden rounded-lg border border-red-200 bg-white shadow-lg transition-all duration-300 hover:shadow-xl">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-red-500 to-red-600 p-6 text-white">
          <div className="absolute inset-0 opacity-10"></div>
          <div className="relative space-y-1">
            <h1 className="text-3xl font-bold tracking-tight">{selectedGame} Registration</h1>
          </div>
        </div>

        <form className="space-y-8 p-6" onSubmit={(e) => {e.preventDefault();
        submitFun();}
        }>


          {/* Sports Section */}
          <div className="space-y-6">
            {/* <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
              <h2>Sports Preference</h2>
            </div> */}

            {/* <div className="space-y-2">
              <label htmlFor="game" className="text-sm font-medium text-gray-700">
                Select Game
              </label>
              <select
                id="game"
                name="game"
                className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                required
                value={selectedGame}
                onChange={(e) => setSelectedGame(e.target.value)}
              >
                <option value="">Select your game</option>
                {games.map((game) => (
                  <option key={game} value={game} >
                    {game}
                  </option>
                ))}
              </select>
            </div> */}
          </div>

          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <h2>Personal Information</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div className="space-y-2">
                <label htmlFor="name" className="text-sm font-medium text-gray-700">
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                    onChange={(e) => setSelectName(e.target.value)}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="phone" className="text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <input
                  type="number"
                  id="phone"
                  name="phone"
                  onChange={(e) => setSelectedNumber(e.target.value)}
                  pattern="^\d{10}$"
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="phone" className="text-sm font-medium text-gray-700">
                  Enrollment Number
                </label>
                <input
                  type="number"
                  id="Enrollment"
                  name="Enrollment"
                  onChange={(e) => setSelectEnrollment(e.target.value)}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  placeholder="Enter your Enrollment number"
                  required
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="password" className="text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={selectPassword}
                  onChange={(e) => setSelectPassowrd(e.target.value)}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  placeholder="Enter your Enrollment number"
                  required
                />
              </div>
            </div>

            {/* Gender Selection */}
            <div className="space-y-3">
              <label className="text-sm font-medium text-gray-700">Gender</label>
              <div className="flex space-x-6">
                <label className="flex cursor-pointer items-center gap-2">
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    onChange={(e) => setSelectedGender(e.target.value)}
                    className="h-4 w-4 cursor-pointer text-red-500 focus:ring-red-500"
                  />
                  <span className="text-sm text-gray-600">Male</span>
                </label>
                <label className="flex cursor-pointer items-center gap-2">
                  <input
                    type="radio"
                    name="gender"
                    value="female"
                    onChange={(e) => setSelectedGender(e.target.value)}
                    className="h-4 w-4 cursor-pointer text-red-500 focus:ring-red-500"
                  />
                  <span className="text-sm text-gray-600">Female</span>
                </label>
              </div>
            </div>
          </div>
          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                <path d="M6 12v5c3 3 9 3 12 0v-5" />
              </svg>
              <h2>Academic Information</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              {/* University Selection */}
              <div className="space-y-2">
                <label htmlFor="university" className="text-sm font-medium text-gray-700">
                  University
                </label>
                <select
                  id="university"
                  name="university"
                  value={selectedUniversity}
                  onChange={(e) => {
                    setSelectedUniversity(e.target.value)
                    setSelectedCourse("")
                  }}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  required
                >
                  <option value="">Select your university</option>
                  <option value="DIET">DIET</option>
                  <option value="DIETDS">DIETDS</option>
                  <option value="DICA">DICA</option>
                  <option value="DIM">DIM</option>
                  <option value="DIS">DIS</option>
                  <option value="DIH">DIH</option>

                </select>
              </div>



              {/* Course Selection */}
              <div className="space-y-2">
                <label htmlFor="course" className="text-sm font-medium text-gray-700">
                  Course
                </label>
                <select
                  id="course"
                  name="course"
                  value={selectedCourse}
                  onChange={(e) => setSelectedCourse(e.target.value)}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20 disabled:cursor-not-allowed disabled:bg-gray-100"
                  disabled={!selectedUniversity}
                  required
                >
                  <option value="">
                    {selectedUniversity ? "Select your course" : "First select university"}
                  </option>
                  {getCourses().map((course) => (
                    <option key={course} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
              </div>

              <div className="space-y-2">
                <label htmlFor="semester" className="text-sm font-medium text-gray-700">
                  Semester
                </label>
                <select
                  id="semester"
                  name="semester"
                  onChange={(e) => setSelectSemester(e.target.value)}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  required
                >
                  <option value="">Select your semester</option>
                  <option value="1">1</option>  
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                </select>
              </div>

            </div>
          </div>
          {/* Personal Information Section */}
          

          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <h2>T-Shirt Size</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div className="space-y-2">
                <label htmlFor="size" className="text-sm font-medium text-gray-700">
                  Size
                </label>
                <select
                  id="size"
                  name="size"
                  onChange={(e) => setSelectedSize(e.target.value)}
                  className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                  required
                >
                  <option value="">Select your size</option>
                  <option value="S">XS</option>
                  <option value="S">S</option>
                  <option value="M">M</option>
                  <option value="L">L</option>
                  <option value="XL">XL</option>
                  <option value="XL">XXL</option>
                  <option value="XL">XXXL</option>

                </select>
              </div>
            </div>
          </div>



          {/* Academic Information Section */}




          {/* Submit Button */}

          <button
            type="submit"
            className="w-full rounded-md bg-gradient-to-r from-red-500 to-red-600 px-4 py-3 text-sm font-semibold text-white transition-all duration-300 hover:from-red-600 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-red-500/20"
          >
            Submit Registration
          </button>
            <div className="text-center text-gray-600">
                <p>Already Registered? <a href="/login" className="text-blue-500 hover:underline">Login</a></p>
            </div>

        </form>
      </div>
      </>:
      <>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md text-center">
        <div className="bg-gradient-to-b from-[#190003] to-red-500 p-8 rounded-lg shadow-xl">
          {/* Email Icon */}
          <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full flex items-center justify-center">
            <svg
              className="w-12 h-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>

          {/* Message */}
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Check Your Email
          </h1>
          <p className="text-white/80 mb-4">
            We've sent a verification link to your email address. Please check your inbox and click the link to verify your account.
          </p>

          {/* Timer */}
          {!canResend && (
            <p className="text-white/60 mb-8">
              Resend available in: {formatTime(timer)}
            </p>
          )}

          {/* Buttons */}
          <div className="space-y-4">
            <button
              className={`w-full py-3 px-4 rounded-md transition-colors duration-300 font-medium
                ${canResend
                  ? 'bg-white text-red-500 hover:bg-red-50'
                  : 'bg-white/50 text-red-500/50 cursor-not-allowed'}`}
              onClick={handleResendEmail}
              disabled={!canResend}
            >
              Resend Email
            </button>
            <button
              className="w-full bg-transparent text-white border border-white/20 py-3 px-4 rounded-md hover:bg-white/10 transition-colors duration-300"
              onClick={() => window.history.back()}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
      </>
    }
    </div>
  )
}




